import React from 'react';
import { MobileNavItem, MobileNavL1Nav, MobileNavSection } from '../mobile-nav.react-component';
import { BusinessPlansButton, PersonalPlanButton } from '../plans-and-pricing/plans-and-pricing-buttons.react-component';
export const MobilePlansAndPricingNav = () => {
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-plans-and-pricing"
  }, /*#__PURE__*/React.createElement(MobileNavSection, null, /*#__PURE__*/React.createElement(MobileNavItem, null, /*#__PURE__*/React.createElement(PersonalPlanButton, null)), /*#__PURE__*/React.createElement(MobileNavItem, null, /*#__PURE__*/React.createElement(BusinessPlansButton, null))));
};
//# sourceMappingURL=mobile-plans-and-pricing-nav.react-component.js.map